import { defineAsyncComponent } from "vue";

export default {
  path: "configure",
  meta: { title: "Configure" },
  component: defineAsyncComponent(() => import("../../pages/configure/index.vue")),
  redirect: "/configure/overview",
  children: [
    {
      path: "overview",
      meta: { title: "Overview" },
      component: defineAsyncComponent(() => import("../../pages/configure/overview/index.vue")),
    },
    {
      path: "virtualNetworks",
      meta: { title: "Virtual Networks" },
      component: defineAsyncComponent(() => import("../../pages/configure/virtual-networks/index.vue")),
    },
    // {
    //   path: "licenses",
    //   meta: { title: "Licenses" },
    //   component: defineAsyncComponent(() => import("../../pages/configure/licenses")),
    // },
    {
      path: "multicast",
      meta: { title: "Multicast" },
      component: defineAsyncComponent(() => import("../../pages/configure/multicast/index.vue")),
    },
    {
      path: "linkAggregation",
      meta: { title: "Link Aggregation" },
      component: defineAsyncComponent(() => import("../../pages/configure/link-aggregation/index.vue")),
    },
    // {
    //   path: "maintenance",
    //   meta: { title: "Maintenance" },
    //   component: defineAsyncComponent(() => import("../../pages/configure/maintenance")),
    // },
    {
      path: "maintenance",
      meta: { title: "Maintenance" },
      component: defineAsyncComponent(() => import("../../pages/configure/maintenance/index.vue")),
    },
    // {
    //   path: "powerOverEthernet",
    //   meta: { title: "Power Over Ethernet" },
    //   component: defineAsyncComponent(() => import("../../pages/configure/power-over-ethernet")),
    // },
    // {
    //   path: "portConfiguration",
    //   meta: { title: "Port Configuration" },
    //   component: defineAsyncComponent(() => import("../../pages/configure/port-configuration")),
    // },
    {
      path: "powerOverEthernet",
      meta: { title: "Power Over Ethernet" },
      component: defineAsyncComponent(() => import("../../pages/configure/power-over-ethernet/index.vue")),
    },
    {
      path: "portConfiguration",
      meta: { title: "Port Configuration" },
      component: defineAsyncComponent(() => import("../../pages/configure/port-configuration/index.vue")),
    },
    {
      path: "security",
      meta: { title: "Security" },
      component: defineAsyncComponent(() => import("../../pages/configure/security/index.vue")),
    },
    // {
    //   path: "virtualNetworks",
    //   meta: { title: "Virtual Networks" },
    //   component: defineAsyncComponent(() => import("../../pages/configure/virtual-networks")),
    // },
    {
      path: "neighbor",
      meta: { title: "Neighbor" },
      component: defineAsyncComponent(() => import("../../pages/configure/neighbor/index.vue")),
    },
  ],
};
